export class ApprovalDelegationEntity {
  public id!: string;
  public teamId!: string;
  public teamName!: string;
  public delegatedUserId!: string | null;
  public delegatedName!: string | null;
}
